import Vue from 'vue'
import VueRouter from 'vue-router'

// 注册路由组件
import Index from '@/views/homepage/Index.vue'
import HomePage from '@/views/homepage/HomePage.vue'
import ComfyUI from '@/views/homepage/ComfyUI.vue'
import TrainModel from '@/views/homepage/TrainModel.vue'
import BatchGenerationCenter from '@/views/homepage/BatchGenerationCenter.vue'
import GeneRate from '@/views/homepage/GeneRate.vue'
import PromptImage from '@/views/homepage/generate/PromptImage.vue'
import Image2Image from '@/views/homepage/generate/Image2Image.vue'
import FluxP2I from '@/views/homepage/generate/FluxP2I.vue'
import FluxI2I from '@/views/homepage/generate/FluxI2I.vue'

import FuncTion from '@/views/function/FuncTion.vue'
import MatTing from '@/views/function/MatTing.vue'
import EditImage from '@/views/premiumapp/EditImage.vue'
import Videomatting from '@/views/function/Videomatting.vue'
import VideoUpscale from '@/views/function/VideoUpscale.vue'

import BroadPicture from '@/views/function/BroadPicture.vue'
import RemoveContainer from '@/views/function/RemoveContainer.vue'
import RealisticHD from '@/views/function/RealisticHD.vue'
import ImageSegmentation from '@/views/function/ImageSegmentation.vue'
import VideoGeneration from '@/views/videoGeneration/VideoGeneration.vue'
import ProductRetouching from '@/views/premiumapp/ProductRetouching.vue'
import VideoScriptReverse from '@/views/premiumapp/VideoScriptReverse.vue'
import VideoSound from '@/views/premiumapp/VideoSound.vue'
import VideoClip from '@/views/premiumapp/VideoClip.vue'
import ColorCardRetouching from '@/views/premiumapp/ColorCardRetouching.vue'
import MultiAngleGeneration from '@/views/premiumapp/MultiAngleGeneration.vue'
import ProductSplicing from '@/views/premiumapp/ProductSplicing.vue'
import VideoStitching from '@/views/premiumapp/VideoStitching.vue'

// 精品应用
import ImageEditIndex from '@/views/premiumapp/ImageEditIndex.vue'

// 模板
import MoreJoy from '@/views/template/MoreJoy.vue'

// 跳转传参模板
import NormalTemp from '@/views/template/NormalTemp.vue'

// 使用手册
import ServiceManual from '@/views/manual/ServiceManual.vue'
Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/index/homepage' },
  { path: '*', redirect: '/404', hidden: 1 },
  { path: '/broadpicture', component: BroadPicture },
  { path: '/removecontainer', component: RemoveContainer },
  { path: '/servicemanual', component: ServiceManual },
  { path: '/realistichd', component: RealisticHD },
  { path: '/imagesegmentation', component: ImageSegmentation },
  // 自动裁剪
  { path: '/autocrop', component: () => import('@/views/function/AutoCrop.vue') },
  { path: '/videogeneration', component: VideoGeneration },
  { path: '/productretouching', component: ProductRetouching },
  { path: '/videoscriptreverse', component: VideoScriptReverse },
  { path: '/videosound', component: VideoSound },
  { path: '/videoclip', component: VideoClip },
  { path: '/colorcardretouching', component: ColorCardRetouching },
  { path: '/multianglegeneration', component: MultiAngleGeneration },
  { path: '/productsplicing', component: ProductSplicing },
  { path: '/videostitching', component: VideoStitching },
  { path: '/blendimage', component: () => import('@/views/premiumapp/BlendImage.vue') },
  { path: '/videomatting', component: Videomatting },
  { path: '/videoupscale', component: VideoUpscale },

  // 个人记录
  { path: '/userimagelog', component: () => import('@/views/userImageLog/index.vue') },

  // 系统维护
  { path: '/development', component: () => import('@/views/homepage/DevelopMent.vue') },

  // 取色器
  { path: '/colorpicker', component: () => import('@/views/function/ColorPicker') },

  // 讨论区
  { path: '/disscussboard', component: () => import('@/components/DiscussionBoard.vue') },

  // 精品应用
  {
    path: '/imageeditindex',
    component: ImageEditIndex,
    redirect: '/imageeditindex/gpt4-0',
    children: [
      { path: 'kontext_v1', component: () => import('@/views/premiumapp/KonText_V1.vue') },
      { path: 'kontext_v2', component: () => import('@/views/premiumapp/KonText_V2.vue') },
      { path: 'gpt4-0', component: () => import('@/views/premiumapp/GPT4-0.vue') },
      { path: 'editimage', component: EditImage },
      { path: 'labshow', component: () => import('@/views/premiumapp/LabShow.vue') }
    ]
  },

  // 更换甲片
  { path: '/fingernailchange', component: () => import('@/views/premiumapp/FingernailChange.vue') },

  // 测试替换甲片
  { path: '/testfingernailchange', component: () => import('@/views/premiumapp/TestFingernailChange.vue') },

  // 甲片迁移（色卡匹配替换）
  { path: '/nailtiptransfer', component: () => import('@/views/premiumapp/NailTipTransfer.vue') },

  // 手部修复
  { path: '/handsrecover', component: () => import('@/views/premiumapp/HandsRecover.vue') },

  // 局部重绘
  { path: '/partialredraw', component: () => import('@/views/function/PartialRedraw.vue') },

  // 万物迁移
  { path: '/universalmigrate', component: () => import('@/views/function/UniversalMigrate.vue') },

  // InstantID
  {
    path: '/instantidIndex',
    component: () => import('@/views/premiumapp/InstantIdIndex.vue'),
    redirect: '/instantindex/instantid_v1',
    children: [
      { path: 'instantid_v1', component: () => import('@/views/premiumapp/InstantId_v1.vue') }
    ]

  },

  // 跳转传参模板
  { path: '/normaltemp', component: NormalTemp },
  // 模板
  { path: '/morejoy', component: MoreJoy },
  { path: '/commonsd1.5', component: () => import('@/views/template/CommonSD1.5.vue') },
  { path: '/commonsdxl', component: () => import('@/views/template/CommonSDXL.vue') },
  // 图生图Flux模板
  { path: '/fluximage2image', component: () => import('@/views/template/FluxImageGen.vue') },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: 1
  },
  {
    path: '/404',
    redirect: '/index/homepage',
    component: HomePage,
    hidden: 1
  },
  {
    path: '/function',
    component: FuncTion,
    redirect: '/function/matting',
    children: [
      { path: 'matting', component: MatTing },
      { path: 'matting_pro', component: () => import('@/views/function/MatTing_Pro.vue') }
    ]
  },
  {
    path: '/index',
    component: Index,
    children: [
      { path: 'homepage', component: HomePage },
      { path: 'morejoyassistant', component: () => import('@/views/morejoyAssistant/MoreJoyAssistant.vue') },
      { path: 'morejoyassistant_LLM', component: () => import('@/views/morejoyAssistant/MoreJoyAssistant_LLM.vue') },
      { path: 'morejoyassistant_script', component: () => import('@/views/morejoyAssistant/MoreJoyAssistant_Script.vue') },
      { path: 'comfyui', component: ComfyUI },
      { path: 'appdownload', component: () => import('@/views/manual/AppDownLoad.vue') },
      { path: 'trainmodel', component: TrainModel },
      { path: 'imagecenter', component: BatchGenerationCenter },
      { path: 'videosource', component: () => import('@/views/homepage/VideoSourceCenter.vue') },
      { path: 'imageGeneration', component: () => import('@/views/imageGeneration/index.vue') },
      {
        path: 'generate',
        component: GeneRate,
        redirect: 'generate/promptimage',
        children: [
          { path: 'promptimage', component: PromptImage },
          { path: 'image2image', component: Image2Image },
          { path: 'fluxp2i', component: FluxP2I },
          { path: 'fluxi2i', component: FluxI2I }
        ]
      }
    ]
  }
]
const router = new VueRouter({
  mode: 'history', // require service support
  routes
})

export default router
